import React from "react";
import { Link } from "react-router-dom";

const Agent = (props) => {
  const { name, img } = props.agent;
  return (
    <div className='column'>
      <Link className='user' to={"/agents/" + name}>
        <div className='name uppercase text-gray-400 font-black tracking-widest'>
          {name}
        </div>
        <img src={img} className='avatar' alt='' />
      </Link>
    </div>
  );
};

export default Agent;
